import constructionImage from "../assets/underDeveliop.png";

const Develop = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
        padding: "2rem",
        textAlign: "center",
        gap: "2rem",
      }}
    >
      <img
        src={constructionImage}
        alt="Under Construction"
        style={{
          maxWidth: "400px",
          width: "100%",
          height: "auto",
          objectFit: "contain",
          opacity: "0.5",
        }}
      />
      <div>
        <h1
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: "rgb(44 62 80 / 54%)",
          }}
        >
          Under Development
        </h1>
        <p
          style={{
            fontSize: "1.1rem",
            color: "rgb(44 62 80 / 54%)",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          We are working hard to bring you an amazing new feature. Please check
          back soon!
        </p>
      </div>
    </div>
  );
};

export default Develop;
